<template>
  <section>
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="true"
    />
    <div>
      <template-recovery>
        <template #banner>
          <img
            src="~@/assets/images/banners/password.svg"
            alt="Esqueci minha senha"
          />
        </template>
        <template #contentHeader>
          <h2 v-if="primeiroAcesso === true">
            {{ $t('senha-cadastro.titulo') }}
          </h2>
          <h2 v-else>
            {{ $t('senha-recuperacao.titulo') }}
          </h2>
          <h3 v-if="primeiroAcesso === true">
            {{ $t('senha-cadastro.subtitulo') }}
          </h3>
          <h3 v-else>
            {{ $t('senha-recuperacao.subtitulo') }}
          </h3>
        </template>
        <template #content>
          <div class="reset-password">
            <div class="cards-container">
              <div class="card-form">
                <form-recovery
                  @submitForm="obterContatos"
                  v-model.lazy="registro"
                  :input-data-label="labelRegister"
                  v-show="!mostrarContatos"
                  :link-register-recovery="true"
                  @input="applyMask()"
                  :maxlength="maxlength"
                  :disabled-button="botaoDesabilitado"
                />
                <div class="cards-container" v-if="mostrarContatos">
                  <card-item
                    v-for="contato in contatos"
                    :key="contato.Contato"
                    :titulo="
                      contato.Tipo === 'E'
                        ? $t('recuperar-registro.por-email')
                        : $t('recuperar-registro.por-celular')
                    "
                    :descricao="'Termina em ' + contato.Contato"
                    @aoClicarCard="enviarLinkRecuperacao(contato)"
                  />
                </div>
              </div>
            </div>
            <modal-template v-if="showModal" class="override-modal">
              <template #header>
                <h2>{{ modalText.titulo }}</h2>
              </template>
              <template #body>
                <p>{{ modalText.subtitulo }}</p>
              </template>
              <template #footer>
                <button
                  id="loginmodal"
                  class="button button-primary"
                  @click="toggleInfoModal"
                >
                  {{ modalText.btnTexto }}
                </button>
              </template>
            </modal-template>
          </div>
        </template>
      </template-recovery>
    </div>
  </section>
</template>

<script>
import TemplateRecovery from '@/components/recovery/TemplateRecovery'
import CardItem from '@/components/shared/cards/CardItem'
import FormRecovery from '@/components/recovery/FormRecovery'
import ModalTemplate from '@/components/shared/modal/ModalTemplate'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RecuperarSenha',
  components: {
    ModalTemplate,
    TemplateRecovery,
    CardItem,
    FormRecovery
  },
  props: {
    primeiroAcesso: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFullPage: true,
      labelRegister: this.$t('login.label-register'),
      maxlength: '7',
      registro: '',
      contatos: [],
      showModal: false,
      modalText: {
        titulo: '',
        subtitulo: '',
        btnTexto: '',
        redirecionarInicio: true
      }
    }
  },
  computed: {
    ...mapGetters({
      allContacts: 'allContacts',
      isLoading: 'isLoading'
    }),
    botaoDesabilitado() {
      return this.registro.length < this.maxlength
    },
    mostrarContatos() {
      return this.contatos.length > 0
    },
    replaceCPF: function () {
      const unmaskCPF = this.registro.replace(/[^A-Za-z0-9]+/g, '')
      return unmaskCPF
    }
  },
  methods: {
    ...mapActions(['listContactsAction', 'recuperarSenha', 'getContatos']),
    async obterContatos() {
      this.contatos = await this.getContatos(this.replaceCPF)
    },
    toggleInfoModal() {
      this.showModal = !this.showModal
      if (this.modalText.redirecionarInicio) {
        this.$router.push('/')
      }
    },
    errorText() {
      this.modalText = {
        titulo: this.$t('erro.padrao.titulo'),
        subtitulo: this.$t('erro.padrao.subtitulo'),
        btnTexto: this.$t('botoes.confirmar'),
        redirecionarInicio: false
      }
      this.showModal = !this.showModal
    },
    okTexto() {
      this.modalText = {
        titulo: this.$t('senha-redefinicao.sucesso.titulo'),
        subtitulo: this.$t('senha-redefinicao.sucesso.subtitulo'),
        btnTexto: this.$t('botoes.entrar'),
        redirecionarInicio: true
      }
      this.showModal = !this.showModal
    },
    returnHome() {
      this.$router.push('/')
    },
    applyMask() {
      const checkCpf = !isNaN(parseInt(this.registro.charAt(0)))
      if (checkCpf) {
        this.registro = this.mCPF(this.cpf)
        this.maxlength = '14'
      } else {
        this.maxlength = '7'
      }
      return this.registro
    },
    mCPF(cpf) {
      cpf = cpf.replace(/\D/g, '')
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      return cpf
    },
    enviarLinkRecuperacao(contato) {
      if (contato.Tipo === 'E') {
        this.enviarEmail({ Username: this.registro, Contato: contato.Contato })
      } else {
        this.enviarSms({ Username: this.registro, Contato: contato.Contato })
      }
    },
    async enviarSms(dadosContato) {
      await this.recuperarSenha({ ...dadosContato })
        .then(() => {
          this.modalText = {
            titulo: this.$t('senha-recuperacao.telefone.titulo'),
            subtitulo: this.$t('senha-recuperacao.telefone.subtitulo'),
            btnTexto: this.$t('botoes.confirmar'),
            redirecionarInicio: true
          }
          this.showModal = !this.showModal
        })
        .catch((error) => {
          this.modalText = {
            titulo: this.$t('erro.padrao.titulo'),
            subtitulo: this.$t('erro.padrao.subtitulo') + '\n' + error.message,
            btnTexto: this.$t('botoes.confirmar'),
            redirecionarInicio: false
          }
          this.showModal = !this.showModal
        })
    },
    async enviarEmail(dadosContato) {
      await this.recuperarSenha({ ...dadosContato })
        .then(() => {
          this.modalText = {
            titulo: this.$t('senha-recuperacao.email.titulo'),
            subtitulo: this.$t('senha-recuperacao.email.subtitulo'),
            btnTexto: this.$t('botoes.confirmar'),
            redirecionarInicio: true
          }
          this.showModal = !this.showModal
        })
        .catch((error) => {
          this.modalText = {
            titulo: this.$t('erro.padrao.titulo'),
            subtitulo: this.$t('erro.padrao.subtitulo') + '\n' + error.message,
            btnTexto: this.$t('botoes.confirmar'),
            redirecionarInicio: false
          }
          this.showModal = !this.showModal
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';

.recovery-content {
  .img-container {
    p {
      font-size: 0.875rem;

      color: var(--gray-700);
      text-align: center;
      i {
        padding-right: 0.3125rem;
        &:before {
          font-size: 1.5rem;
          position: relative;
          top: 0.3125rem;
        }
      }
    }
  }
  .cards-container {
    margin-top: 1.875rem;
  }
  .card-form {
    max-width: 22.125rem;
  }
}
.state-container {
  padding-top: 12rem;
}
@media (min-width: 768px) {
  .state-container {
    max-height: 100%;
    padding-right: 3rem;
    padding-left: 3rem;
  }
}
</style>
